import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { get, map, find } from 'lodash';
import { formatDataValue } from '@/helpers/format';
import { HistoryItem, HistoryListItem } from '@/types/History';

export type Getters = {
  getHistoryForPortfolio(state: State): Array<HistoryItem> | null;
  getHistoryListItems(state: State, id: string): Array<HistoryListItem> | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getHistoryForPortfolio: state => {
    const historyState = get(state, 'history', null);

    if (historyState) {
      return map(historyState, item => {
        const historyItem = {
          id: get(item, 'id.dataValue', ''),
          title: get(item, 'title.dataValue', ''),
          status: get(item, 'status.dataValue', ''),
          date: formatDataValue(item.date, { showTime: true }),
          user: get(item, 'user.dataValue', ''),
          isCompleted: get(item, 'isCompleted.dataValue', false),
          historyType: get(item, 'historyType.dataValue', ''),
        } as HistoryItem;
        if (item.profit) {
          historyItem.profit = formatDataValue(item.profit) as string;
        }
        if (item.roa) {
          historyItem.roa = formatDataValue(item.roa) as string;
        }
        return historyItem;
      });
    }

    return null;
  },
  getHistoryListItems: (state, id) => {
    const historyListState = get(state, 'historyList', null);

    if (historyListState && id) {
      const foundItem = find(historyListState, x => x.id === id);
      if (foundItem && foundItem.data) {
        return map(
          foundItem.data,
          item =>
            ({
              timestamp: formatDataValue(item.timestamp, {
                showTime: true,
              }),
              eventType: get(item, 'eventType.dataValue', ''),
              baseEventType: get(item, 'baseEventType.dataValue', ''),
              roles: map(get(item, 'roles', []), role =>
                get(role, 'dataValue', '')
              ),
              employeeId: get(item, 'employeeId.dataValue', ''),
              outcome: get(item, 'outcome.dataValue', ''),
              comment: get(item, 'comment.dataValue', ''),
            } as HistoryListItem)
        );
      }
    }

    return null;
  },
};
